import antNotification, { type ArgsProps as NotificationArgsProps } from "antd/lib/notification";

type NotificationType = "success" | "error" | "info" | "warning";

interface NotificationProps extends Omit<NotificationArgsProps, "type"> {
    message: string;
    description?: string;
}

const NOTIFICATION_DEFAULTS = {
    placement: "topRight",
    duration: 4,
} as const;

const createNotificationHandler =
    (type: NotificationType) =>
    ({ message, description, ...props }: NotificationProps) => {
        antNotification[type]({
            message,
            description,
            ...NOTIFICATION_DEFAULTS,
            ...props,
        });
    };

const NOTIFICATION_TYPES = ["success", "error", "info", "warning"] as const;

const notification = Object.fromEntries(
    NOTIFICATION_TYPES.map(type => [type, createNotificationHandler(type)]),
) as Record<NotificationType, ReturnType<typeof createNotificationHandler>> & {
    useNotification: typeof antNotification.useNotification;
};

notification.useNotification = antNotification.useNotification;

export { notification };
